<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-title>Take photo</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="onClose">Done</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="floating-helper-text text-center" style="color:#999;">
        <div>
          <span>Upload up to 3 photos.</span>
        </div>
        <div>
          <span>Try getting good lighting and different angles.</span>
        </div>
      </div>
      <ul class="photos-gallery">
        <li
          v-for="(file, i) of files"
          :key="i"
          @click="presentPopover($event, file, i)"
        >
          <file-thumbnail :fileId="file._fileId" />
        </li>
        <li v-if="files.length < fileLimit">
          <div class="photos-thumbnail">
            <input
              type="file"
              accept="image/*"
              multiple
              data-role="none"
              class="photos-upload-input visually-hidden"
              ref="upload"
              @change="handleUpload"
            />
            <button class="photos-upload-button" @click="openUpload">
              <img src="@/assets/camera-button.png" />
            </button>
          </div>
        </li>
        <li v-for="(f, i) of filesLeft" :key="'left-' + i">
          <div class="photos-thumbnail">
            <button class="photos-upload-button" @click="openUpload">
              <img src="@/assets/image-placeholder.png" />
            </button>
          </div>
        </li>
      </ul>
    </ion-content>
  </div>
</template>

<script>
import { store } from "../store";
import FileThumbnail from "./FileThumbnail.vue";
import PhotoActionsPopover from "./PhotoActionsPopover.vue";

export default {
  name: "PhotosModal",
  components: {
    FileThumbnail
  },
  props: ["data", "onPhotos"],
  data() {
    return {
      files: this.data || [],
      fileLimit: 3,
      loading: false
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.files.length < 1) {
        this.openUpload();
      }
    }, 200);
  },
  computed: {
    filesLeft() {
      return Math.max(0, this.fileLimit - this.files.length - 1);
    }
  },
  methods: {
    onClose() {
      if (!this.loading) {
        this.onSubmit();
      }
    },
    onSubmit() {
      if (typeof this.onPhotos === "function") {
        this.onPhotos(this.files);
      }
      this.$ionic.modalController.dismiss();
    },
    openUpload() {
      const upload = this.$refs.upload;
      if (upload) {
        upload.click();
      }
    },
    handleUpload(e) {
      this.loading = true;
      let fileList = e.target.files;
      let keys = Object.keys(fileList);
      const quota = this.fileLimit - this.files.length;
      if (keys.length > quota) {
        this.$ionic.alertController
          .create({
            header: "Exceded Photo Limit",
            message:
              "You exceded the photo limit of 3. All photos exceding the limit will be ignored.",
            buttons: ["OK"]
          })
          .then(a => a.present());
        if (quota > 0) {
          keys = keys.slice(0, quota);
        }
      }
      for (let key of keys) {
        const file = fileList[key];
        store.dispatch("addFile", file).then(id => {
          this.files.push({ _fileId: id });
        });
      }
      e.target.value = "";
      this.loading = false;
    },
    presentPopover(e, file, i) {
      const onDelete = function() {
        this.$delete(this.files, i);
        this.$ionic.popoverController.dismiss();
      }.bind(this);
      return this.$ionic.popoverController
        .create({
          component: PhotoActionsPopover,
          event: e,
          translucent: true,
          componentProps: {
            propsData: {
              file,
              onDelete
            }
          }
        })
        .then(popover => popover.present());
    }
  }
};
</script>

<style lang="scss" scoped>
ion-content {
  --background: #f7f7f7;
}

.photos-gallery {
  margin: 0;
  padding: 0;
  li {
    display: inline-block;
    list-style: none;
    margin-right: 15px;
    vertical-align: top;
  }
}

.photos-thumbnail {
  border: 1px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);
  border-radius: 5px;
  width: 80px;
  height: 80px;
  background: white;
  position: relative;
  overflow: hidden;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}

.visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}

/* Separate rule for compatibility, :focus-within is required on modern Firefox and Chrome */
input.visually-hidden:focus + label {
  outline: thin dotted;
}
input.visually-hidden:focus-within + label {
  outline: thin dotted;
}

.photos-upload-button {
  background: white;
  width: 100%;
  height: 100%;
}

.floating-helper-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
}
</style>
